/**
 * Decrypt invite
 *
 * @param {Object} data
 *
 * @return {Object}
 */
export default function decryptInvite (data) {
    try {
        return JSON.parse(decode(data, process.env.INVITE_DECRYPT_KEY));
    } catch (error) {
        return {};
    }
}

const decode = (message, key) => {
    if (typeof message !== 'string') {
        return null;
    }

    const length = key.length;
    const fromCharCode = String.fromCharCode;

    return message.replace(/[\s\S]/g, function (char, i) {
        return fromCharCode(key.charCodeAt(i % length) ^ char.charCodeAt(0));
    });
};
